import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { getCurrentUser } from '@aws-amplify/auth';
import { forkJoin } from 'rxjs';
import { NotaCreditoProveedorService } from 'src/app/services/api/notaCreditoProveedor.sales.service';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.css'],
})
export class ConfirmDeleteComponent implements OnInit {
  codigo: any;
  loading: boolean = false;
  success: boolean = false;
  numMonto: boolean = false;

  messageResult: String = '';
  iconResult: any;
  usuario: any;
  dataSelect: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    private NCPService: NotaCreditoProveedorService
  ) {}

  ngOnInit(): void {
    this.loadCurrentUser();
  }

  private async loadCurrentUser(): Promise<void> {
    try {
      const user = await getCurrentUser();
      this.usuario = user.signInDetails?.loginId || user.username;
    } catch (error) {
      console.error('Error al obtener usuario actual:', error);
      this.usuario = 'usuario-desconocido';
    }
  }

  onSave() {
    if (this.loading) return;
    this.loading = true;
    this.data.onConfirm();
    this.NCPService.deleteNotaCreditoProveedor({ id: this.data.id }).subscribe({
      next: (result: any) => {
        console.log('result', result);
        if (result.errors) {
          this.notificationService.notifyError(result.errors[0].message);
          return;
        }

        this.success = true;
        this.loading = false;
        this.notificationService.showSuccessAlertPersonalizado(
          'Eliminado',
          'Las NCP se elimino correctamente.',
          () => this.OnClose()
        );
      },
      error: (e: any) => {
        this.success = false;
        this.loading = false;
        this.notificationService.showErrorssAlertPersonalizado(
          'Error al Eliminar NCP',
          e || 'No se pudo eliminar una o más NCP.',
          () => this.OnClose()
        );
      },
    });
  }

  OnClose() {
    this.dialogRef.close({
      success: this.success,
    });
  }
  onCancel() {
    this.OnClose();
  }

  ngOnDestroy(): void {
    this.OnClose();
  }
}
